import { MessageBanner, MessageBannerType } from "@amzn/stencil-react-components/message-banner";
import { View } from "@amzn/stencil-react-components/layout";
import { getString } from "@/common/uistringlabels/ui-string-utils";
import React from "react";

/**
 * Displayed when the current user lacks the permission required to access
 * a route. Shows an explicit unauthorized message rather than a 404, since
 * a 404 reads as a broken page and drives support tickets.
 */
const UnauthorizedPage: React.FC = () => {
  return (
    <View padding="2rem" dataTestId="unauthorized-page">
      <MessageBanner type={MessageBannerType.Error} isDismissible={false}>
        {getString("errors.notAuthorized")}
      </MessageBanner>
    </View>
  );
};

export default UnauthorizedPage;
